module.exports = __webpack_public_path__ + "img/1524024147.cad10b16.jpg";